export const GALACTUS_SOCKET_IO_PATH = '/galactus';

export interface GalactusSocketConfig {
  origin: string;
  path: string;
}

/**
 * Derive Socket.IO origin + path from a configured Galactus URL.
 *
 * Examples:
 * - https://staging-apis.pencilapp.com
 *   → origin host, path /galactus (GAE)
 * - https://staging-apis.pencilapp.com/galactus-k8s
 *   → path /galactus-k8s/galactus (GKE stage/prod)
 * - https://staging-apis.pencilapp.com/galactus-k8s/preview-<PR_ID>
 *   → path /galactus-k8s/preview-<PR_ID>/galactus (GKE preview)
 */
export function resolveGalactusSocketConfig(url: string): GalactusSocketConfig {
  const parsed = new URL(url);
  const origin = `${parsed.protocol}//${parsed.host}`;
  let pathname = parsed.pathname || '/';

  if (pathname !== '/' && pathname.endsWith('/')) {
    pathname = pathname.slice(0, -1);
  }

  if (pathname === '' || pathname === '/') {
    return { origin, path: GALACTUS_SOCKET_IO_PATH };
  }

  if (pathname.endsWith(GALACTUS_SOCKET_IO_PATH)) {
    return { origin, path: pathname };
  }

  return { origin, path: `${pathname}${GALACTUS_SOCKET_IO_PATH}` };
}
